export default __webpack_public_path__ + "static/media/google_play_fr.8e14ee63.png";